import { KeyDataType } from '@/proto/token';

export type AreaFieldValue = {
  operator?: string;
  key?: string;
  values?: string[] | string;
  type?: KeyDataType;
  name?: string;
};

export enum AreaNameEnum {
  ClientCountry = 'client_country',
  ClientProvince = 'client_province',
  ClientCity = 'client_city',
  ElectronClientCountry = 'country',
  ElectronClientProvince = 'province',
  ElectronClientCity = 'city',
}
